(ns com.theplantscape.plant-web.draw.points
  (:require
   [com.theplantscape.plant-web.draw.state :refer [default-units]]
   [com.theplantscape.conversions.ensemble :refer [convert-units]]))

(defonce svg-scale 10)
;; old functions don't update
;(def scale-meters 1000)

(defn sqr [n] (* n n))

(defn distance
  ([[x1 y1] [x2 y2]] (distance [x1 y1] [x2 y2] (default-units)))
  ([[x1 y1] [x2 y2] units]
   (-> (+ (sqr (- x2 x1))
          (sqr (- y2 y1)))
       (Math/sqrt)
       (convert-units units)
       .toFixed)

   #_(.toFixed (Math/sqrt (+ (sqr (- x2 x1))
                             (sqr (- y2 y1))))
               2)))

(defn points->middle [[x1 y1] [x2 y2]]
  [(/ (+ x1 x2) 2)
   (/ (+ y1 y2) 2)])

(defn points->str
  "Convert points to a space separated string"
  [points]
  (apply str (interpose " " (flatten points))))

(defn points->str-1 [points]
  (apply str (map #(str " T " (points->str %)) (partition 1 points))))

(defn points->str-3 [points]
  (apply str (map #(str " Q " (points->str %)) (partition 3 points))))

(defn distance-between-points [[x1 y1] [x2 y2]]
  (let [xdist (- x1 x2)
        ydist (- y1 y2)]
    (.sqrt js/Math
           (+
            (* xdist xdist)
            (* ydist ydist)))))

(defn points-close?
  ([[x1 y1] [x2 y2]] (points-close? [x1 y1] [x2 y2] 10.00))
  ([[x1 y1] [x2 y2] distance]
   (<  (distance-between-points [x1 y1] [x2 y2]) distance)))
